module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/faq_photograph_02_sp-abdaf0e36c536eb9f7c164524c3cec8f.png";